import { Link } from "react-router-dom";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { ArrowRight, UserPlus, Users, Award, MapPin, Zap, Mail, Phone } from "lucide-react";

const INCENTIVI = [
  { icon: UserPlus, titolo: "Esonero Giovani", desc: "Contributi azzerati per chi assume a tempo indeterminato giovani under 36 che non abbiano mai avuto un contratto a tempo indeterminato.", dettagli: "L'agevolazione dura fino a 24 mesi (36 mesi nel Mezzogiorno) con un tetto massimo di 500 euro mensili (650 euro nel Sud), ed è valida per assunzioni fino al 31 dicembre 2025, con proroga fino al 2027." },
  { icon: Users, titolo: "Incentivo Donne", desc: "Esonero totale dei contributi (fino a 650 euro al mese) per chi assume donne disoccupate da almeno 6 mesi in aree svantaggiate o da 24 mesi in qualsiasi area.", dettagli: "L'agevolazione è valida per assunzioni a tempo determinato (12 mesi), indeterminato (18 mesi) o per trasformazioni contrattuali. Valida per le assunzioni a tempo indeterminato fino al 2027." },
  { icon: Award, titolo: "Assunzioni over 50", desc: "Agevolazione del 50% della contribuzione dovuta dai datori di lavoro che assumono a tempo determinato, indeterminato o con trasformazione, lavoratori over-50 disoccupati da oltre 12 mesi.", dettagli: "La durata dell'incentivo è di 12 mesi per tempo determinato, 18 mesi per tempo indeterminato e 18 mesi complessivi se rapporto trasformato. Deve determinare un incremento occupazionale netto." },
  { icon: MapPin, titolo: "Decontribuzione Sud", desc: "Agevolazione per le aziende che assumono in regioni del Mezzogiorno con sconti contributivi.", dettagli: "Progressivamente ridotti fino al 2029. Un'opportunità significativa per le imprese che operano nelle regioni meridionali." },
  { icon: Zap, titolo: "Incentivo Occupazione NEET", desc: "Sgravio del 60% della retribuzione per assunzioni a tempo indeterminato di giovani NEET (non impegnati in studio o lavoro).", dettagli: "Rivolto ai giovani che non sono impegnati in percorsi di studio, formazione o lavoro, per favorirne l'inserimento nel mondo produttivo." },
];

export default function AssunzioniAgevolatePage() {
  return (
    <main id="main-content">
      {/* Hero */}
      <section className="relative h-[280px] md:h-[320px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1920&q=60&auto=format" alt="Assunzioni agevolate" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-10">
          <HeroBreadcrumb />
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Assunzioni agevolate</h1>
          <p className="text-lg text-white/80 mt-3 max-w-3xl">Opportunita per le imprese, incentivi e formazione con Confcommercio Roma!</p>
        </div>
      </section>

      {/* Apprendistato */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-4">Apprendistato finanziato: un'opportunità per le PMI</h2>
            <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">Ogni anno la Regione Lazio finanzia la formazione obbligatoria per gli apprendisti assunti con contratto di apprendistato, sia per le competenze di base che per quelle trasversali.</p>
            <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">Grazie al <strong className="text-[var(--confcom-text-primary)]">Fondo Sociale Europeo</strong>, i corsi sono <strong className="text-[var(--confcom-text-primary)]">completamente gratuiti</strong> per le piccole e medie imprese.</p>
            <p className="text-[var(--confcom-text-secondary)] leading-relaxed">La procedura e stata semplificata: le aziende possono ora accedere direttamente ai corsi contattando <strong className="text-[var(--confcom-text-primary)]">Promo.Ter Confcommercio Roma</strong>.</p>
          </div>
        </div>
      </section>

      {/* Sgravi contributivi */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-4">Assunzioni agevolate: sgravi contributivi per le aziende</h2>
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-10">Confcommercio Roma supporta le imprese nell'accesso a queste opportunità, semplificando le procedure e offrendo consulenza mirata.</p>
          <div className="grid md:grid-cols-2 gap-6">
            {INCENTIVI.map((inc) => (
              <div key={inc.titolo} className="bg-white rounded-xl border border-[var(--confcom-border)] p-6">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 bg-[var(--confcom-bg-blue-light)] rounded-lg flex items-center justify-center shrink-0 mt-1">
                    <inc.icon size={22} className="text-[var(--confcom-blue)]" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{inc.titolo}</h3>
                    <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed mb-2">{inc.desc}</p>
                    {inc.dettagli && (
                      <p className="text-sm text-[var(--confcom-text-muted)] leading-relaxed">{inc.dettagli}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/cta-background.jpg" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.88)" }} />
        </div>
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Per maggiori informazioni</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mt-3 mb-8">Contattaci</h2>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 text-left" data-testid="assunzioni-agevolate-contatti">
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-white/80">
                <Mail size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="mailto:sindacale@confcommercioroma.it" className="hover:text-white transition-colors">sindacale@confcommercioroma.it</a>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <Phone size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="tel:+390668437221" className="hover:text-white transition-colors">Tel: 06 68437 221-290</a>
              </div>
            </div>
          </div>

          <Link
            to="/chi-siamo/struttura-tecnica#ufficio-lavoro-e-welfare"
            data-testid="assunzioni-agevolate-scopri-team"
            className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-6 py-3 rounded-md font-semibold hover:bg-white/90 transition-colors text-sm mt-8"
          >
            Scopri il Team <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </section>
    </main>
  );
}
